import { FC } from "react";
import ContentLoader from "react-content-loader";

const CardReviewLoader: FC = props => (
	<ContentLoader
		style={{ minWidth: "330px" }}
		speed={2}
		width={"100%"}
		height={100}
		viewBox="0 0 330 100"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb"
		{...props}
	>
		<rect x="20" y="20" rx="0" ry="0" width="165" height="10" />
		<rect x="20" y="38" rx="0" ry="0" width="80" height="10" />
		<rect x="20" y="57" rx="0" ry="0" width="235" height="8" />
		<rect x="20" y="70" rx="0" ry="0" width="150" height="8" />
		<rect x="240" y="83" rx="0" ry="0" width="70" height="9" />
	</ContentLoader>
);

export default CardReviewLoader;
